import {Box, Radio, Typography} from '@mui/material';
import {forwardRef} from 'react';
import styles from '../aur-select-dropdown/style.module.scss';
import {t} from 'i18next';

interface ISelectItem {
  [key: string]: string | number;
}

type SelectItemProps = {
  itemData: ISelectItem;
  itemDisplay: string | number;
  isSelected: boolean;
  isExpanded: boolean;
  onItemClick: (data: ISelectItem) => void;
};

const SelectedItem = forwardRef<HTMLLIElement, SelectItemProps>(
  ({itemData, itemDisplay, isSelected, isExpanded, onItemClick}, ref) => {
    const imageSrc = isSelected
      ? '/assests/images/radio-checked.svg'
      : '/assests/images/radio-unchecked.svg';
    return (
      <Box
        ref={ref}
        onClick={() => onItemClick(itemData)}
        className={`${styles.aurSelectItem} ${isSelected && styles.aurAllSelectItemChecked}`}
        aria-hidden={isExpanded}
      >
        <Radio checked={isSelected} checkedIcon={<img src={imageSrc} alt={t('common.img')} />} />
        <Typography className={styles.aurAllSelectLabel}>
          {itemData[itemDisplay]}
        </Typography>
      </Box>
    );
  }
);

export default SelectedItem;
